import { render, staticRenderFns } from "./recents.vue?vue&type=template&id=3180855c&scoped=true&"
import script from "./recents.vue?vue&type=script&lang=js&"
export * from "./recents.vue?vue&type=script&lang=js&"
import style0 from "./recents.vue?vue&type=style&index=0&id=3180855c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3180855c",
  null
  
)

export default component.exports